var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper",class:{hideSidebar:!_vm.sidebar.opened}},[(!_vm.POWERED_BY_QIANKUN)?_c('sidebar',{staticClass:"sidebar-container"}):_vm._e(),_vm._v(" "),_c('div',{class:{'main-container': !_vm.POWERED_BY_QIANKUN}},[(!_vm.POWERED_BY_QIANKUN)?_c('navbar',{key:_vm.key}):_vm._e(),_vm._v(" "),_c('app-main',{on:{"displayNameChange":_vm.handleDisplayNameChange}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fcf447a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Layout.vue
// module id = Zf8a
// module chunks = 83